import {networkDeviceConstants} from "../constants/network-device.constants";

const initState ={
    list: null,
    singleDevice: null,
    simpleDeviceInfo: null,
    loader: false,
    loaderMsg: null,
    validationForm: null,
    lockRefresh: false,
    dropdownList: null,
};

export function networkDeviceReducer(state = initState, action) {
    switch (action.type) {
        case networkDeviceConstants.NETWORK_DEVICE_LIST_REQUEST:
            return  {
                ...state,
                validationForm: null,
                lockRefresh: true
            }
        case networkDeviceConstants.NETWORK_DEVICE_LIST_SUCCESS:
            return {
                ...state,
                list: action.networkDeviceModel,
                validationForm: null,
                lockRefresh: false
            };
        case networkDeviceConstants.NETWORK_DEVICE_LIST_FAILURE:
            return {
                ...state,
                list: null,
                validationForm: null,
                lockRefresh: false
            };
        case networkDeviceConstants.NETWORK_DEVICE_LIST_CLEAR:
            return {
                ...state,
                list: null,
                validationForm: null
            };
        case networkDeviceConstants.NETWORK_DEVICE_BY_ID_REQUEST:
            return {
                ...state,
                singleDevice: null,
                validationForm: null
            };
        case networkDeviceConstants.NETWORK_DEVICE_BY_ID_SUCCESS:
            return {
                ...state,
                singleDevice: action.networkDeviceModel,
                validationForm: null
            };
        case networkDeviceConstants.NETWORK_DEVICE_BY_ID_ERROR:
            return {
                ...state,
                singleDevice: null,
                validationForm: null
            };
        case networkDeviceConstants.NETWORK_DEVICE_SIMPLE_MODEL_REQUEST:
            return {
                ...state,
                simpleDeviceInfo: null,
                validationForm: null
            };
        case networkDeviceConstants.NETWORK_DEVICE_SIMPLE_MODEL_SUCCESS:
            return {
                ...state,
                simpleDeviceInfo: action.networkDeviceSimpleModel,
                validationForm: null
            };
        case networkDeviceConstants.NETWORK_DEVICE_SIMPLE_MODEL_FAILURE:
            return {
                ...state,
                simpleDeviceInfo: null,
                validationForm: null
            };
        case networkDeviceConstants.NETWORK_DEVICE_LOADER_SHOW:
            return {
                ...state,
                loader: true,
                loaderMsg: action.msg
            };
        case networkDeviceConstants.NETWORK_DEVICE_LOADER_HIDE:
            return {
                ...state,
                loader: false,
                loaderMsg: null,
            };
        case networkDeviceConstants.NETWORK_DEVICE_VALIDATION_FORM:
            return {
                ...state,
                validationForm: action.error.response.data
            };
        case networkDeviceConstants.NETWORK_DEVICE_DROPDOWN_LIST:
            return {
                ...state,
                dropdownList: action.dropdown
            }
        default:
            return state
    }
}
